import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastService } from '../../core/services/toast.service';
import { ReportsService } from '../reports.service';

const ROUTES = {
  licenses: 'licenses',
  groups: 'groups',
  students: 'students',
  events: 'events',
  activity: 'activity',
  surveys: 'surveys'
};

@Component({
  selector: 'lms-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {
  private reportingSubscription: Subscription;
  public personalization: any;
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public reportsService: ReportsService,
    public toastService: ToastService
  ) {}

  public ngOnInit(): void {
    this.reportingSubscription = this.route.data.subscribe((routeData) => {
      if (routeData.personalization) {
        this.personalization = routeData.personalization;
        this.viewReport(this.personalization);
      }
    });
  }

  viewReport(report: any) {
    this.reportsService.setLastReport(report);
    this.router.navigate(['reports', this.getReportRoute(report.type)], {
      queryParams: { reportId: report.id }
    });
  }

  public ngOnDestroy(): void {
    this.reportingSubscription.unsubscribe();
  }

  private getReportRoute(reportType) {
    switch (reportType) {
      case 'licensesBreakdown':
        return ROUTES.licenses;
      case 'assessment':
      case 'applicability':
      case 'selfassessment':
        return ROUTES.surveys;
      default:
        return reportType;
    }
  }

  sendReport(event) {
    this.toastService.showOk('', 3000, false);
  }
}
